import BaseService from './BaseService'

class ModifierService extends BaseService {
  constructor() {
    super('/modifiers')
  }

  async list({ modifierGroupId = null } = {}) {
    return this.customRequest('get', '', null, {
      params: modifierGroupId ? { modifier_group_id: modifierGroupId } : {}
    })
  }

  async get(id) {
    return this.getById(id)
  }

  async createModifier(payload) {
    return this.create(payload)
  }

  async updateModifier(id, payload) {
    return this.update(id, payload)
  }
}

export const modifierService = new ModifierService()

